import { ccwpApi } from "@/services";

export const TasksApi = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    getClaimTasksListByCase: builder.query<any, any>({
      query: ({ Status, ...args }) => {
        let statusesURL = "ClaimTask/ListClaimTasksByCase";
        if (Status?.length > 0) {
          Status?.forEach((status: string, index: number) => {
            statusesURL += `${index === 0 ? "?" : "&"}Statuses=${status}`;
          });
        }
        return {
          url: statusesURL,
          method: "GET",
          params: { ...args },
        };
      },
    }),
  }),
});
export const { useGetClaimTasksListByCaseQuery } = TasksApi;
